import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Upload, UploadFile } from 'antd';
import { MediaHelpers } from '@wajeez-web/core/api';
import { UploadChangeParam } from 'antd/es/upload';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import InputLabel from '../Inputs/InputLabel';
import { UploadImageInputTypeV2 } from './types';

export const UploadImageInputV2 = React.forwardRef<
  HTMLInputElement,
  UploadImageInputTypeV2
>(
  (
    {
      id,
      label,
      placeholder = '',
      disabled,
      required = false,
      readOnly,
      shape = 'squre',
      textColorClassName = 'text-textPrimary',
      bgColorClassName = 'bg-white',
      value,
      onChange,
      inputExtraClassNames,
      isError,
      fieldState,
      span,
    },
    ref
  ) => {
    const [src, setSrc] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
      if (value) {
        MediaHelpers.getPublicMediaByIdAsync(value)
          .then((res) => {
            setSrc(res);
          })
          .catch(() => {
            setSrc('');
          });
      } else setSrc('');
    }, [value]);

    const onPreview = async (file: UploadFile) => {
      let src = file.url;
      if (!src && file.originFileObj != undefined) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj as Blob);
          reader.onload = () => resolve(reader.result as string);
        });
      }
      const image = new Image();
      image.src = src ?? '';
      const imgWindow = window.open(src);
      imgWindow?.document.write(image.outerHTML);
    };

    const handleChange = async (e: UploadChangeParam<UploadFile<any>>) => {
      const file = e.fileList?.[0];

      if (file) {
        setIsLoading(true);
        try {
          const res = await MediaHelpers.uploadMedia({
            data: file,
            fileName: file.name,
          });

          onChange && res && onChange(res);
        } catch (error) {
          console.log(error);
        }
        setIsLoading(false);
      }
    };

    return (
      <div
        className={`relative flex flex-col justify-center rtl:items-start ltr:items-end ${
          isError ? 'border-red-500' : ''
        }  `}
      >
        {label && (
          <InputLabel
            text={t(`inputs.labels.${label}`, label.toString() || '') as string}
            name={id ?? ''}
            required={required}
            hint={span}
          />
        )}
        <div>
          <Upload
            disabled={disabled}
            accept="image/*"
            action={async (file) => {
              //   const formData = new FormData();

              //   formData.append('file', file as Blob);

              if (file) {
                setIsLoading(true);
                try {
                  const res = await MediaHelpers.uploadMedia({
                    data: file,
                    fileName: file.name,
                  });

                  onChange && res && onChange(res);
                } catch (error) {
                  console.log(error);
                }
                setIsLoading(false);
              }

              return '';
            }}
            listType="picture-card"
            fileList={
              isNullOrEmpty(src)
                ? []
                : [
                    {
                      uid: src,
                      name: src,
                      url: src,
                    },
                  ]
            }
            onChange={handleChange}
            onRemove={() => {
              onChange && onChange(null);

              setSrc('');
            }}
            onPreview={onPreview}
            className="input"
          >
            {isNullOrEmpty(src) &&
              t(`inputs.labels.${'Upload +'}`, '').toString()}
          </Upload>
        </div>
        {/* </ImgCrop> */}
        {isError && (
          <div className="absolute top-[100%] right-0 text-[12px] text-red-500">
            <ReturnTranslatedText
              origintext={fieldState?.error?.message}
              text={`general.${fieldState?.error?.message}`}
            />
          </div>
        )}
      </div>
    );
  }
);

export const isNullOrEmpty = (str: string | undefined | null) => {
  return str == null || str === undefined || str === '';
};
